import React from 'react'
import Heading from '../../components/header';
import TabDataTable from './dataTable';
import { useState } from 'react';
import './style.css'

const Testing = (props) => {
    const [activeTab, setActiveTab] = useState(0);
    const handleTabClick = (index) => {
        setActiveTab(index);
      }
  return (
    <div>
        <Heading
                text="Testing tab"
                path="#"
                // search={props.viewOrder.filters.search}
                // onSearch={onSearch}
                // exportToCSV={props.onExportToCSV}
        />
        <div className="testing-tab-group">
      <ul className="testing-tab-list">
        <li className={`tab ${activeTab === 0 && 'active'}`} onClick={() => handleTabClick(0)}>Approved</li>
        <li className={`tab ${activeTab === 1 && 'active'}`} onClick={() => handleTabClick(1)}>Rejected</li>
        <li className={`tab ${activeTab === 2 && 'active'}`} onClick={() => handleTabClick(2)}>Pending</li>
        <li className={`tab ${activeTab === 3 && 'active'}`} onClick={() => handleTabClick(3)}>InProgress</li>
        <li className={`tab ${activeTab === 4 && 'active'}`} onClick={() => handleTabClick(4)}>Payment</li>

      </ul>
      <div className="testing-tab-content">
        {activeTab === 0 && <TabDataTable />}
        {activeTab === 1 && <TabDataTable />}
        {activeTab === 2 && <TabDataTable />}
        {activeTab === 3 && <TabDataTable />}
        {activeTab === 4 && <TabDataTable />}

      </div>
    </div>
       
    </div>
  )
}

export default Testing